import { CmsIconListItem, CmsMultiContent } from '@domgen/dgx-fe-cms';

export interface CmsApplianceDetailsSteppedBenefitsPanel {
  additionalBenefit?: string;
  benefits: CmsMultiContent<CmsIconListItem>;
  title: string;
}
